<template>
    <div class="Protocol container">
        <div class="Protocol-content">
            <template v-if="protocolObj.id">
                <a
                    v-if="language==='zh'"
                    class="Protocol-download zh"
                    :href="protocolUrl.zh_url"
                    target="_blank">下载PDF</a>
                <a
                    v-if="language==='en'"
                    class="Protocol-download en"
                    :href="protocolUrl.en_url"
                    target="_blank">Download PDF</a>
                <div v-if="language==='zh'" v-html="protocolObj.zh_content"></div>
                <div v-if="language==='en'" v-html="protocolObj.en_content"></div>
            </template>
        </div>
        <a-button
            type="primary"
            size="large"
            style="width: 320px;"
            :class="{disable: isDisable}"
            @click="agreeProtocol"
        >{{countDownWord}} {{getLabel('BUTTON_AGREE')}}</a-button>
    </div>
</template>

<script>
	import {mapState, mapGetters} from 'vuex';
    import Language from '../util/language';

    export default {
    	mounted() {
		    this.$store.dispatch('protocol/getProtocol', this.countDown);
        },
    	data() {
    		return {
    			countDownNum: 10,
    			isDisable: true
            }
        },
	    computed: {
		    ...mapState({
			    language: state => state.main.language,
			    protocolObj: state => state.protocol.protocolObj
		    }),
		    ...mapGetters('protocol', {
			    protocolUrl: 'protocolUrl'
		    }),
		    countDownWord: function() {
		    	return this.countDownNum > 0 ? this.countDownNum + 's' : '';
            }
	    },
	    methods: {
		    // 获取描述
		    getLabel: function (key) {
			    return Language(this.language, key);
		    },
            // 倒数计
            countDown: function () {
		    	let _this = this;
                let timer = setInterval(() => {
	                _this.countDownNum--;
                	if (_this.countDownNum === 0) {
                		clearInterval(timer);
                		this.isDisable = false;
                    }
                }, 1000);
            },
            // 同意协议
		    agreeProtocol: function () {
                if (this.isDisable) {
                	return;
                }
			    this.$store.dispatch('protocol/agreeProtocol');
			    if (this.language === 'zh') {
				    this.$router.push('/information');
			    } else {
				    this.$router.push('/en/information');
			    }
		    }
        }
    }
</script>

<style lang="less">
    .Protocol {
        width: 1000px;
        margin: 0 auto;
        padding-bottom: 40px;
        &-content {
            position: relative;
            margin-top: 30px;
            margin-bottom: 40px;
            h1 { font-size: 32px; }
            h2 { font-size: 24px; }
            h3 { font-size: 18px; }
            h4 { font-size: 16px; }
            h5 { font-size: 13px; }
            h6 { font-size: 10px; }
        }
        &-download {
            display: block;
            position: absolute;
            top: 0;
            right: -130px;
            font-size: 16px;
            color: #666;
            padding-left: 25px;
            background: url(../assets/img/pdf.png) left center no-repeat;
            background-size: 16px;
            &:hover {
                color: #2099F3;
                background: url(../assets/img/pdf_b.png) left center no-repeat;
                background-size: 16px;
            }
        }
        .ant-btn {
            display: block;
            margin: 0 auto;
            &.disable {
                background: #BDBDBD;
                border: none;
            }
        }
    }
</style>
